<template>
  <section class="companypass">
    <div class="companypass__content container">
      <div class="companypass__content--image">
        <img src="@/assets/location/luchetti.jpeg" alt="Luchetti Salon">
      </div>
      <div class="companypass__content--info">
        <h1 class="companypass__title">
          Secure your presentation spot by registering directly, early birds can pick up their time and date if available.
        </h1>
        <a href="https://buy.stripe.com/7sI6qSfL02xq3ZudQW" target="_blank" class="companypass__btn btn">
          <button class="button">Get Your Company Pass</button>
        </a>
      </div>
    </div>
  </section>
</template>


<script>

export default {
  name: 'Company Pass',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/components/companypass.scss";
</style>